// src\themes\choopar\components\Banner.tsx
import Image from "next/image";
import Link from "next/link";
import { Heading } from "@/components/ui/Heading";
import { BannerData } from "@/core/types/about-us";
import CustomButton from "./CustomButton";
import FullWidth from "@/components/shared/FullWidth";
import { getSiteConfig } from "@/core/config/theme-config";
import { cn } from "@/core/lib/utils";

interface BannerProps {
  data: BannerData;
}

const isVideoUrl = (url?: string) => {
  if (!url) return false;
  return /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url);
};

export default function Banner({ data }: BannerProps) {
  const { siteName } = getSiteConfig();
  const isArozh = siteName === "arozhdecor";

  return (
    <FullWidth className="col-span-12 relative max-h-[70vh] aspect-video overflow-hidden">
      {data.image && (
        isVideoUrl(data.image.url) ? (
          <video
            src={data.image.url}
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
          />
        ) : (
          <Image
            src={data.image?.url}
            alt={data.title || "some picture"}
            className="w-full h-full object-cover"
            fill
          />
        )
      )}
      <div className="absolute inset-0 bg-black/40 flex items-center">
        <div
          className={cn(
            "flex flex-col space-y-1 px-12",
            isArozh ? "w-fit max-w-full lg:max-w-[48%]" : "w-full lg:w-[48%]"
          )}
        >
          <Heading level={1} className="text-white text-[calc(.8rem+0.3vw)]">
            {data.title}
          </Heading>
          <p className="text-white/90 text-sm">{data?.subtitle}</p>
          <p className="text-white/90 text-xs">{data?.description}</p>
          {data.buttonContent && data.link && (
            <div className={cn("mt-2", isArozh && "flex justify-center")}>
              <CustomButton
                asChild
                className={cn(
                  isArozh && "rounded-full !border-0 shadow-lg shadow-black/30 backdrop-blur-sm"
                )}
              >
                <Link href={data.link}>{data.buttonContent}</Link>
              </CustomButton>
            </div>
          )}
        </div>
      </div>
    </FullWidth>
  );
}